<template>
    <div class="mx-auto max-w-7xl flex flex-grow flex-col">

        <div class="flex" v-if="initial_price_screenrecording">
            <div class="sm:px-6 lg:px-8 flex flex-grow pt-12">
                <a href="/billing"
                    class="px-6 py-4 lg:px-8 flex w-full h-full flex-grow items-center justify-between border border-green-300 rounded-md bg-green-100 hover:bg-green-200 text-sm text-gray-900">
                    <span>Get your bills or update your payment informations</span>
                    <ChevronRightIcon class="w-5 h-5" />
                </a>
            </div>
        </div>

        <div class="flex">


            <div class="mx-auto sm:px-6 lg:px-8 flex flex-grow pt-12">


                <main class="mx-auto w-full pb-10">

                    <div v-if="is_grace_period"
                        class="rounded-md p-4 border-yellow-500 border bg-yellow-100 text-yellow-600 flex flex-col gap-y-3 mb-10">
                        <p>Your subscription has been canceled and will stay active until <strong>{{
                            grace_period_end
                                }}</strong>.</p>
                        <p class="flex items-center gap-x-2 justify-between">
                            <span>You can still resume your current subscription before it ends.</span>
                            <button
                                class="bg-blue-500 text-white hover:bg-blue-600 flex items-center justify-center rounded-md py-2 px-3 text-sm font-medium uppercase gap-x-2"
                                @click="gotoResume" :disabled="is_resuming">
                                <span>Resume</span>
                                <spinner v-if="is_resuming" class="w-4 h-4 mx-0.5" />
                                <ArrowUturnRightIcon v-else class="w-5 h-5" />
                            </button>
                        </p>
                    </div>

                    <div class="flex items-center justify-end gap-x-3 pr-1">

                        <div class="flex items-center">
                            <h2 class="text-sm font-medium leading-6 text-gray-600">Billing Period</h2>
                        </div>

                        <RadioGroup v-model="billPlan" class="">
                            <RadioGroupLabel class="sr-only">Choose a billing period option</RadioGroupLabel>
                            <div class="grid grid-cols-2 gap-3 sm:grid-cols-2">
                                <RadioGroupOption as="template" value="monthly">
                                    <div
                                        :class="[billPlan == 'monthly' ? 'bg-blue-500 text-white hover:bg-blue-600' : 'ring-1 ring-inset ring-gray-300 bg-white text-gray-900 hover:bg-gray-50', 'flex items-center justify-center rounded-md py-2 px-2 text-xs font-semibold uppercase sm:flex-1 cursor-pointer focus:outline-none']">
                                        <RadioGroupLabel as="span">Monthly</RadioGroupLabel>
                                    </div>
                                </RadioGroupOption>
                                <RadioGroupOption as="template" value="yearly">
                                    <div
                                        :class="[billPlan == 'yearly' ? 'bg-blue-500 text-white hover:bg-blue-600' : 'ring-1 ring-inset ring-gray-300 bg-white text-gray-900 hover:bg-gray-50', 'flex items-center justify-center rounded-md py-2 px-2 text-xs font-semibold uppercase sm:flex-1 cursor-pointer focus:outline-none']">
                                        <RadioGroupLabel as="span">Yearly</RadioGroupLabel>
                                    </div>
                                </RadioGroupOption>
                            </div>
                        </RadioGroup>
                    </div>
                    <div class="text-gray-600 mt-2 text-right text-xs pr-2">
                        Save up to <strong>20%</strong> with yearly billing
                    </div>




                    <div class="mt-5 flex items-center gap-x-2 pl-1">
                        <img src="/img/screen-recording.svg" class="w-6 h-6" alt="Screen Recording">
                        <span class="font-space uppercase tracking-widest">Screen Recording</span>
                    </div>
                    <PricingBlocks :available_plans="available_plans_screenrecording"
                        :selected_plan="selected_plan_screenrecording" @changePlan="changedPlan"
                        @changeSeats="changedSeats" :billPlan="billPlan" :active_seats="active_screenrecording_seats"
                        :is_free_trial="is_free_trial" type="screenrecording" />
                    <div class="mt-2 text-blue-600 text-sm pl-1">
                        For Screen Recording pricing details, please go to <a
                            href="https://www.birdie.so/pricing#screen-recording" target="_blank"
                            title="Birdie pricing details"
                            class="underline hover:text-blue-500">https://www.birdie.so/pricing</a>
                    </div>






                    <div v-if="contact_sales" class="flex items-center justify-end gap-x-3 pr-1 mt-5">
                        <div class="">
                            <a class="bg-blue-500 text-white hover:bg-blue-600 flex items-center justify-center rounded-md py-2 px-3 text-sm font-medium uppercase sm:flex-1 gap-x-2"
                                href="mailto:hey@birdie.so?subject=About My Subscription">
                                <span>Contact us</span>
                                <EnvelopeIcon class="w-5 h-5" />
                            </a>
                        </div>
                    </div>

                    <div v-if="!contact_sales" class="flex items-center justify-end gap-x-3 pr-1 mt-10">

                        <h2 class="font-medium leading-6 text-gray-600">Total:</h2>
                        <h1 class="font-bold text-right"><span v-if="fullPriceCurrency == 'usd'">$</span>{{
                            fullPrice.toLocaleString() }}<span v-if="fullPriceCurrency == 'eur'">€</span></h1>
                        <h1 class="font-bold text-right">/ <span
                                v-html="billPlan == 'yearly' ? 'year' : 'month'"></span>
                        </h1>

                    </div>
                    <div v-if="billPlan == 'monthly' && fullPrice > 0 && !contact_sales"
                        class="flex items-center justify-end text-right gap-x-3 mt-1 text-sm text-gray-600">
                        You will be charged automatically every month. Taxes may apply.
                    </div>
                    <div v-else-if="fullPrice > 0 && !contact_sales"
                        class="flex items-center justify-end text-right gap-x-3 mt-1 text-sm text-gray-600">
                        Yearly plan we will automatically charge you once for the full year. Taxes may apply.
                    </div>

                    <div v-if="!contact_sales" class="flex items-center justify-end gap-x-3 pr-1 mt-5">
                        <div class="">
                            <button v-if="plan_changed"
                                :class="[
                                    is_subscribed && only_free_selected ? 'border-yellow-500 border bg-yellow-100 text-yellow-600' : 'bg-blue-500 text-white hover:bg-blue-600',
                                    'flex items-center justify-center rounded-md py-2 px-3 text-sm font-medium uppercase sm:flex-1 gap-x-2']"
                                @click="gotoChange" :disabled="is_resuming">
                                <span v-if="is_subscribed && only_free_selected">Downgrade</span>
                                <span v-else-if="is_subscribed && fullPrice != current_price">Proceed</span>
                                <span v-else-if="!is_subscribed && fullPrice > 0">Upgrade</span>

                                <spinner v-if="is_resuming" class="w-4 h-4 mx-0.5" />
                                <CheckIcon v-else-if="is_subscribed && only_free_selected" class="w-5 h-5" />
                                <CheckIcon v-else-if="is_subscribed && fullPrice != current_price" class="w-5 h-5" />
                                <ArrowRightIcon v-else-if="!is_subscribed && fullPrice > 0" class="w-5 h-5" />
                            </button>

                            <!-- <button v-else-if="current_price == 0 && fullPrice == 0" class="bg-white text-blue-600 border border-blue-600 hover:bg-blue-50 flex items-center justify-center rounded-md py-2 px-3 text-sm font-medium uppercase sm:flex-1 gap-x-2">
                                <span>Free</span>
                                <ArrowRightIcon class="w-5 h-5" /></button> -->

                            <button v-else-if="is_grace_period"
                                class="bg-blue-500 text-white hover:bg-blue-600 flex items-center justify-center rounded-md py-2 px-3 text-sm font-medium uppercase sm:flex-1 gap-x-2"
                                @click="gotoResume" :disabled="is_resuming">
                                <span>Resume</span>
                                <spinner v-if="is_resuming" class="w-4 h-4 mx-0.5" />
                                <ArrowUturnRightIcon v-else class="w-5 h-5" />
                            </button>

                            <button v-else
                                class="text-gray-400 border border-gray-400 bg-gray-100 flex items-center justify-center rounded-md py-2 px-3 text-sm font-medium uppercase sm:flex-1 gap-x-2 cursor-default">
                                <span>Current subscription</span>
                            </button>
                        </div>
                    </div>










                    <div v-if="false" class="mx-auto w-full max-w-5xl mt-8">

                        <jet-section-border />

                        <div class="flex flex-col justify-center px-4">
                            <p class="text-center font-bold text-gray-800 text-lg mb-5">Frequently Asked
                                Questions</p>
                            <list-toggle>
                                <template #title>
                                    Is tax included in all the prices?
                                </template>
                                <template #content>
                                    <div class="rounded-xl p-5 bg-gray-100">
                                        <p>It isn't. Additional taxes may apply depending on your country.</p>
                                    </div>
                                </template>
                            </list-toggle>

                        </div>

                    </div>


                </main>

























            </div>

        </div>

    </div>

</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import JetButton from '@/Jetstream/Button'
import JetButtonLink from '@/Jetstream/ButtonLink'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import ListToggle from '@/Components/UI/ListToggle'
import PricingBlocks from '@/Components/PricingBlocks'
import Spinner from '@/Components/UI/Spinner'
import { InformationCircleIcon, ArrowRightIcon, ArrowUturnRightIcon, XMarkIcon, CheckIcon } from "@heroicons/vue/20/solid";
import { MinusCircleIcon, PlusCircleIcon, EnvelopeIcon } from "@heroicons/vue/24/outline";
import { RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue'
import { ChevronRightIcon } from "@heroicons/vue/24/solid";



export default {
    props: ["the_plans", "current_frequency", "is_free_trial",
        "current_plan_name", "is_subscribed", "is_grace_period", "grace_period_end",
        "active_screenrecording_seats"], //, "has_enterprise_access"],
    components: {
        AppLayout, JetButton, JetSecondaryButton, ArrowRightIcon, MinusCircleIcon, PlusCircleIcon, EnvelopeIcon,
        JetSectionBorder, ListToggle, JetButtonLink, InformationCircleIcon,
        PricingBlocks, XMarkIcon, CheckIcon, Spinner, ArrowUturnRightIcon,
        RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption,
        ChevronRightIcon
    },
    layout: AppLayout, // keep layout in place avoid refreshing it

    data() {
        return {
            billPlan: this.current_frequency || "yearly",
            plans: this.the_plans,
            domain: this.$page.props.app_url.split('.').slice(-2).join('.'),
            app_name: this.$page.props.app_name,
            available_plans_screenrecording: [],
            selected_plan_screenrecording: null,
            // available_plans_cobrowsing: [],
            // selected_plan_cobrowsing: null,

            is_resuming: false,

            // billingPeriods: [
            //     { name: 'Monthly', available: true },
            //     { name: 'Yearly', available: true}
            // ],
            // selected_period: null,
            //is_subscribed: false,
            current_screenrecording_seats: 1,
            // current_cobrowsing_seats: 1,
            current_price: 0,
            fullPrice: 0,
            fullPriceCurrency: 'eur',

            current_price_screenrecording: '',
            // current_price_cobrowsing: '',

            initial_price_screenrecording: '',
            // initial_price_cobrowsing: '',
            initial_screenrecording_seats: 1,
            // initial_cobrowsing_seats: 1
            contact_sales: false
        }
    },

    created() {

        // console.log(this.plans)
        // this.selected_period = this.billingPeriods[1]

        this.available_plans_screenrecording = []
        // this.available_plans_cobrowsing = []

        for (var i = 0; i < this.the_plans.length; i++) {
            if (this.the_plans[i].product_type == "screenrecording") {
                this.available_plans_screenrecording.push(this.the_plans[i])
            }
            // else if (this.the_plans[i].product_type == "cobrowsing") {
            //     this.available_plans_cobrowsing.push(this.the_plans[i])
            // }
        }

        // for (var i = 0; i < this.available_plans_cobrowsing.length; i++) {
        //     if (this.available_plans_cobrowsing[i].is_current_plan) {
        //         this.selected_plan_cobrowsing = this.available_plans_cobrowsing[i]
        //         this.current_cobrowsing_seats = this.available_plans_cobrowsing[i].is_current_plan.quantity ?? 1
        //         this.initial_cobrowsing_seats = this.current_cobrowsing_seats
        //         break
        //     }
        // }

        for (var i = 0; i < this.available_plans_screenrecording.length; i++) {
            if (this.available_plans_screenrecording[i].is_current_plan) {
                this.selected_plan_screenrecording = this.available_plans_screenrecording[i]
                this.current_screenrecording_seats = this.available_plans_screenrecording[i].is_current_plan.quantity ?? 1
                this.initial_screenrecording_seats = this.current_screenrecording_seats
                break
            }
        }

        if (this.selected_plan_screenrecording && this.selected_plan_screenrecording.monthly_id) {
            this.initial_price_screenrecording = this.current_frequency == 'monthly' ? this.selected_plan_screenrecording.monthly_id : this.selected_plan_screenrecording.yearly_id
        }
        // if (this.selected_plan_cobrowsing && this.selected_plan_cobrowsing.monthly_id) {
        //     this.initial_price_cobrowsing = this.current_frequency == 'monthly' ? this.selected_plan_cobrowsing.monthly_id : this.selected_plan_cobrowsing.yearly_id
        // }

        // this.selected_plan_cobrowsing = this.available_plans_cobrowsing[1]
        // this.selected_plan_screenrecording = this.available_plans_screenrecording[1]
        this.computeFullPrice()
        this.current_price = this.fullPrice


        // this.EventBus.on("start.call", function(toto) {
        //     this.test(toto)
        // }.bind(this));
    },
    beforeUnmount() {
        // this.EventBus.off("start.call", this.test);
    },
    mounted() {
        //console.log(this.plans)
        // this.EventBus.emit("start.call", "hello")
        // console.log('a', this.current_screenrecording_seats, this.initial_screenrecording_seats)
        // console.log('b', this.current_cobrowsing_seats, this.initial_cobrowsing_seats)
        // console.log('c', this.initial_price_screenrecording, this.current_price_screenrecording)
        // console.log('d', this.initial_price_cobrowsing, this.current_price_cobrowsing)

        let hash = window.location.hash
        if (hash) {
            hash = hash.substring(1)
            if (hash === 'monthly' || hash === 'yearly') {
                this.billPlan = hash
            }
        }

    },
    methods: {
        changedPlan(type, newPlan) {
            if (newPlan == null) {
                return
            }
            console.log(newPlan)
            // if (type == "cobrowsing") {
            //     this.selected_plan_cobrowsing = newPlan
            // } else {
            this.selected_plan_screenrecording = newPlan
            // }
            this.computeFullPrice()
        },
        changedSeats(newSeats, plan) {
            //console.log("changedSeats", newSeats, plan)
            // this.current_cobrowsing_seats = newSeats
            this.computeFullPrice()
        },
        // incrementSeats(plan) {
        //     this.current_cobrowsing_seats++
        //     this.computeFullPrice()
        // },
        // decrementSeats(plan) {
        //     if (this.current_cobrowsing_seats <= 1) {
        //         return
        //     }
        //     this.current_cobrowsing_seats--
        //     this.computeFullPrice()
        // },
        computeFullPrice() {
            //console.log(this.current_cobrowsing_seats, this.selected_plan_screenrecording, this.selected_plan_cobrowsing)
            // console.log("computeFullPrice", this.current_cobrowsing_seats, this.selected_plan_screenrecording, this.selected_plan_cobrowsing)
            if (!this.selected_plan_screenrecording || this.selected_plan_screenrecording.monthly_id == null && this.selected_plan_screenrecording.yearly_id == null) {
                this.contact_sales = true
                return
            } else {
                this.contact_sales = false
            }
            this.fullPriceCurrency = this.selected_plan_screenrecording.currency
            if (this.billPlan == 'yearly') {
                this.fullPrice = this.selected_plan_screenrecording.price.yearly
                this.current_price_screenrecording = this.selected_plan_screenrecording.yearly_id ?? ''
                // this.current_price_cobrowsing = this.selected_plan_cobrowsing.yearly_id ?? ''
                // if (this.selected_plan_cobrowsing.options.tiered) {
                //     this.fullPrice += this.selected_plan_cobrowsing.price.yearly * this.current_cobrowsing_seats
                // } else {
                //     this.fullPrice += this.selected_plan_cobrowsing.price.yearly
                // }
            } else {
                this.fullPrice = this.selected_plan_screenrecording.price.monthly
                this.current_price_screenrecording = this.selected_plan_screenrecording.monthly_id ?? ''
                // this.current_price_cobrowsing = this.selected_plan_cobrowsing.monthly_id ?? ''
                // if (this.selected_plan_cobrowsing.options.tiered) {
                //     this.fullPrice += this.selected_plan_cobrowsing.price.monthly * this.current_cobrowsing_seats
                // } else {
                //     this.fullPrice += this.selected_plan_cobrowsing.price.monthly
                // }
            }
        },

        gotoChange() {
            if (this.is_resuming) {
                return
            }
            if (this.is_subscribed && this.only_free_selected) {
                if (this.is_grace_period) {
                    let options = {
                        type: "info",
                        toastBackgroundColor: '#207FFF', // birdie-blue
                        timeout: 5000,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast(`Your subscription is already set to end on ${this.grace_period_end}`, options)
                    return
                }
                this.gotoCancel()
            } else if (!this.is_subscribed && this.fullPrice > 0) {
                this.gotoCheckout()
            } else if (this.is_subscribed && this.plan_changed) {
                //console.log("PLAN CHANGE")
                this.gotoCheckout()
            }
        },
        gotoResume() {
            if (this.is_subscribed && this.is_grace_period) {
                if (this.is_resuming) {
                    return
                }
                this.is_resuming = true
                this.$inertia.visit(route('subscription.index', { flow: 'resume' }))
            }
        },
        gotoCheckout() {
            if (this.is_resuming) {
                return
            }
            this.is_resuming = true
            var params = {
                sr: {
                    pro: this.selected_plan_screenrecording.product_id,
                    pri: this.billPlan == 'yearly' ? this.selected_plan_screenrecording.yearly_id : this.selected_plan_screenrecording.monthly_id,
                    vol: 0,
                    tier: this.selected_plan_screenrecording.options.tiered
                },
                // cb: {
                //     pro: this.selected_plan_cobrowsing.product_id,
                //     pri: this.billPlan == 'yearly' ? this.selected_plan_cobrowsing.yearly_id : this.selected_plan_cobrowsing.monthly_id,
                //     vol: this.current_cobrowsing_seats,
                //     tier: this.selected_plan_cobrowsing.options.tiered
                // }
            }
            var url = route('checkout', params)
            window.location.href = url
            return

        },
        gotoCancel() {
            if (this.is_resuming) {
                return
            }
            this.is_resuming = true
            var params = { flow: 'cancel' }
            var url = route('billing', params)
            window.location.href = url

        }
    },
    computed: {
        only_free_selected() {
            return this.selected_plan_screenrecording.product_id == null
        },
        plan_changed() {
            if (!this.is_subscribed && this.only_free_selected) {
                return false
            }
            return this.current_frequency != this.billPlan ||
                (this.is_subscribed && this.only_free_selected) ||
                (!this.is_subscribed && !this.only_free_selected) ||
                this.current_screenrecording_seats != this.initial_screenrecording_seats ||
                // this.current_cobrowsing_seats != this.initial_cobrowsing_seats ||
                this.initial_price_screenrecording != this.current_price_screenrecording  // ||
            // this.initial_price_cobrowsing != this.current_price_cobrowsing
        }
        //     is_subscribed() {
        //         return this.current_plan_id != ""
        //     },
        //     is_free_plan() {
        //         return this.current_plan_id == ""
        //     },
        //     is_pro_plan() {
        //         return this.current_plan_name.substr(0, 3) == "Pro"
        //     },
        //     is_enterprise_plan() {
        //         return this.current_plan_name.substr(0, 10) == "Enterprise"
        //     }
    },
    watch: {
        billPlan: function (val, oldVal) {
            this.computeFullPrice()
        },
        // selected_plan_cobrowsing: function (val, oldVal) {
        //     this.computeFullPrice()
        // },
        selected_plan_screenrecording: function (val, oldVal) {
            this.computeFullPrice()
        },
    }
}
</script>

<style scoped>
.fade-enter {
    opacity: 0;
}

.fade-enter-active {
    transition: all 0.2s ease-out;
}

.fade-leave-to {
    opacity: 0;
}

.fade-leave-active {
    transition: all 0.2s ease-in;
}

table tbody tr:hover td {
    /* -webkit-transition: background-color 200ms ease-in-out;
        -ms-transition: background-color 200ms ease-in-out;
        transition: background-color 200ms ease-in-out; */
}

table tbody tr:hover td {
    background: #DBEAFE;
}

th.pspacer {
    width: 2%;
}

th.plabel {
    width: 24%;
}

th.pcol {
    width: 22%;
}
</style>
